import { Component } from 'react';
import PropTypes from 'prop-types';

class TableRowComponent extends Component {
  render() {
    const { row, columnNames } = this.props;
    const columns = columnNames.map(key => (
      <td key={key}>{row[key]}</td>
    ));

    return (
      <tr>
        {columns}
      </tr>
    );
  }
}

TableRowComponent.propTypes = {
  row: PropTypes.shape({}),
  columnNames: PropTypes.arrayOf(PropTypes.string),
};

TableRowComponent.defaultProps = {
  row: {},
  columnNames: [],
};

export default TableRowComponent;
